export const WaiverFieldType = {
  Agreement: 'agreement',
  Text: 'text',
} as const

export type WaiverFieldType =
  typeof WaiverFieldType[keyof typeof WaiverFieldType]

export type WaiverContent = Readonly<{
  id?: string
  content: string
  enabled: boolean
}>

export type GetOpportunityWaiverResponse = Readonly<{
  waiver: WaiverContent | null
}>

export type EditOpportunityWaiverParams = Readonly<{
  opportunityId: string
  waiverId?: string
}> &
  WaiverContent

export type WaiverDto = Readonly<{
  id: string
  opportunityId: string
  type: WaiverFieldType
  content: string
}>
